import React from 'react'
import PropTypes from 'prop-types'
import { styled } from '@material-ui/core/styles'
import { Link } from 'gatsby'

import routes from 'src/routes'

import { ReactComponent as logo  } from 'img/logos/ .svg'
import { ReactComponent as logoStichting } from 'img/logos/stichting.svg'

import {
  AppBar,
  Toolbar,
  Container,
  Slide,
  useScrollTrigger,
  Hidden,
} from '@material-ui/core'

import { Button, Svg } from 'components'

import ProfileMenu from './ProfileMenu'
import HamburgerMenu from './HamburgerMenu'
import menu from './menu'

export const HideOnScroll = ({ children, removeOnExit }) => {
  const trigger = useScrollTrigger()

  return (
    <Slide
      appear={false}
      direction="down"
      in={!trigger}
      style={{ display: trigger && removeOnExit && 'none' }}
    >
      {children}
    </Slide>
  )
}

HideOnScroll.propTypes = {
  children: PropTypes.element.isRequired,
}
const StyledAppbar = styled(AppBar)({
  borderBottom: '2px solid #EFEFEF',
})

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  marginTop: theme.spacing(1),
}))

const Logo Svg = styled(Svg)({
  width: 100,
})

const LogoStichtingSvg = styled(Svg)(({ theme }) => ({
  width: '140px',
  height: '100%',
  fill: theme.palette.primary.dark,
}))

const MenuContainer = styled('div')({
  marginLeft: 'auto',
})

const MenuButton = styled(Button)({
  fontWeight: 'normal',
})
MenuButton.defaultProps = {
  variant: 'text',
  color: 'default',
}

const DashboardButton = styled(MenuButton)(({ theme }) => ({
  marginLeft: theme.spacing(3),
}))
DashboardButton.defaultProps = {
  variant: 'outlined',
}

/*
const ProfileButton = ({ user }) => {
  return <Avatar alt={user.displayName} src={user.photoURL} />
}
*/

const Logo = ({ link }) => {
  const LogoLink = link ? Link : 'div'
  if (__BUILDFOR__ === ' ') {
    return (
      <LogoLink to={link}>
        <Logo Svg svg={logo } alt=" " />
      </LogoLink>
    )
  } else {
    return (
      <LogoLink to={link}>
        <LogoStichtingSvg
          svg={logoStichting}
          alt="Stichting Massaschade &amp; Consument"
        />
      </LogoLink>
    )
  }
}

const Navbar = ({ showMenu, logoLink, removeOnExit, ...props }) => {
  const logoLinkTo = routes[logoLink]

  const menuNoDashboard = [...menu]
  const dashboardMenuItem = menuNoDashboard.pop()

  return (
    <HideOnScroll removeOnExit={removeOnExit}>
      <StyledAppbar elevation={0} color="inherit" position="fixed" {...props}>
        <Container>
          <StyledToolbar disableGutters>
            {showMenu && __BUILDFOR__ === ' ' && (
              <Hidden mdUp implementation="css">
                <HamburgerMenu />
              </Hidden>
            )}
            <Logo link={logoLinkTo} />
            <MenuContainer>
              {showMenu && __BUILDFOR__ === ' ' && (
                <div style={{ display: 'inline-block' }}>
                  <Hidden smDown implementation="css">
                    {menuNoDashboard.map(({ label, to }, i) => (
                      <MenuButton to={to} key={label}>
                        {label}
                      </MenuButton>
                    ))}
                    <DashboardButton to={dashboardMenuItem.to}>
                      {dashboardMenuItem.label}
                    </DashboardButton>
                  </Hidden>
                </div>
              )}
              <ProfileMenu />
            </MenuContainer>
          </StyledToolbar>
        </Container>
      </StyledAppbar>
    </HideOnScroll>
  )
}

export default Navbar
